export default __webpack_public_path__ + "static/media/clientes.75c0bb8c.svg";